"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderTrackingDetail = void 0;
const core_1 = require("@material-ui/core");
const button_1 = require("client/components/material/button");
const switch_1 = require("client/components/material/switch");
const modal_1 = require("client/components/modal");
const ui_1 = require("client/components/ui");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const React = require("react");
const formatUsd_1 = require("shared/util/formatUsd");
const credit_info_1 = require("../credit-info");
const tracking_info_1 = require("../tracking-info");
const styles = core_1.createStyles({
    trackingInfoContainer: {
        margin: "1rem"
    },
    switchBtn: {
        width: "fit-content"
    }
});
const decorate = core_1.withStyles(styles);
let OrderTrackingDetailUnstyled = class OrderTrackingDetailUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.newTrackingDetail = {
            trackingNumber: "",
            trackingLink: "",
            shippingCost: 0,
            distributorId: "",
            expectedDate: ""
        };
        this.newCreditDetail = {
            creditNumber: "",
            note: "",
            creditAmount: 0,
            distributorId: ""
        };
        this.trackingDetailsLocal = [];
        this.creditDetailsLocal = [];
        this.showNewCreditInfo = false;
        this.status = ui_1.FormStatus.Clean;
        this.resetNewTrackingDetail = () => {
            const dummyTrackingDetail = {
                trackingNumber: "",
                trackingLink: "",
                shippingCost: 0,
                distributorId: "",
                expectedDate: ""
            };
            const dummyCreditDetail = {
                creditNumber: "",
                note: "",
                creditAmount: 0,
                distributorId: ""
            };
            this.newTrackingDetail = ramda_1.merge(this.newTrackingDetail, dummyTrackingDetail);
            this.newCreditDetail = ramda_1.merge(this.newTrackingDetail, dummyCreditDetail);
        };
        this.handleOrderTrackingChange = (trackingDetail) => (field) => (event, value) => {
            const trackingDetailFound = this.trackingDetailsLocal.find(td => td.id === trackingDetail.id);
            if (trackingDetailFound) {
                trackingDetailFound[field] = value;
                if (this.status === ui_1.FormStatus.Clean) {
                    this.status = ui_1.FormStatus.Dirty;
                }
            }
        };
        this.handleChangeExpectedDate = (trackingDetail) => (value) => {
            const trackingDetailFound = this.trackingDetailsLocal.find(td => td.id === trackingDetail.id);
            if (trackingDetailFound) {
                trackingDetailFound.expectedDate = value;
                if (this.status === ui_1.FormStatus.Clean) {
                    this.status = ui_1.FormStatus.Dirty;
                }
            }
        };
        this.handleChangeExpectedDateNew = (value) => {
            this.newTrackingDetail.expectedDate = value;
        };
        this.handleOrderCreditChange = (creditDetail) => (field) => (event, value) => {
            const creditDetailFound = this.creditDetailsLocal.find(td => td.id === creditDetail.id);
            if (creditDetailFound) {
                creditDetailFound[field] = value;
            }
        };
        this.handleNewTrackingDetailChange = (field) => (event, value) => {
            this.newTrackingDetail[field] = value;
        };
        this.handleNewCreditDetailChange = (field) => (event, value) => {
            this.newCreditDetail[field] = value;
        };
        this.handleSelect = (trackingDetail) => (value) => {
            const trackingDetailFound = this.trackingDetailsLocal.find(td => td.id === trackingDetail.id);
            if (trackingDetailFound) {
                trackingDetailFound.distributorId = value;
            }
        };
        this.handleSelectCredit = (creditDetail) => (value) => {
            const creditDetailFound = this.creditDetailsLocal.find(td => td.id === creditDetail.id);
            if (creditDetailFound) {
                creditDetailFound.distributorId = value;
            }
        };
        this.handleNewTrackingDetailSelect = (value) => {
            this.newTrackingDetail = ramda_1.merge(this.newTrackingDetail, {
                distributorId: value
            });
        };
        this.handleNewCreditDetailSelect = (value) => {
            this.newCreditDetail = ramda_1.merge(this.newCreditDetail, {
                distributorId: value
            });
        };
        this.renderBlankDetail = () => {
            const { trackingNumber, trackingLink, shippingCost, distributorId, expectedDate } = this.newTrackingDetail;
            return (React.createElement(tracking_info_1.TrackingInfo, { trackingNumber: trackingNumber, trackingLink: trackingLink, shippingCost: shippingCost, distributorOptions: this.props.distributorOptions, expectedDate: expectedDate, distributorSelected: distributorId, onChangeExpectedDate: this.handleChangeExpectedDateNew, onChange: this.handleNewTrackingDetailChange, onSelect: this.handleNewTrackingDetailSelect }));
        };
        this.renderBlankCreditDetail = () => {
            const { creditNumber, note, creditAmount, distributorId } = this.newCreditDetail;
            return (React.createElement(credit_info_1.CreditInfo, { creditNumber: creditNumber, note: note, creditAmount: creditAmount, distributorOptions: this.props.distributorOptions, distributorSelected: distributorId, onChange: this.handleNewCreditDetailChange, onSelect: this.handleNewCreditDetailSelect }));
        };
        this.renderNewTrackingDetail = () => this.renderBlankDetail();
        this.renderNewCreditDetail = () => this.renderBlankCreditDetail();
        this.renderOrderTrackingDetails = () => {
            const trackingDetails = this.trackingDetailsLocal;
            return (React.createElement(React.Fragment, null, trackingDetails &&
                trackingDetails.map((trackingDetail, index) => {
                    const { trackingNumber, trackingLink, shippingCost, expectedDate, distributorId } = trackingDetail;
                    return (React.createElement(tracking_info_1.TrackingInfo, { key: index, trackingNumber: trackingNumber, trackingLink: trackingLink, shippingCost: formatUsd_1.formatUsd(shippingCost), distributorOptions: this.props.distributorOptions, expectedDate: expectedDate, distributorSelected: distributorId, onChangeExpectedDate: this.handleChangeExpectedDate(trackingDetail), onChange: this.handleOrderTrackingChange(trackingDetail), onSelect: this.handleSelect(trackingDetail), shouldDisableShippingCost: true }));
                })));
        };
        this.renderOrderTrackingCreditDetails = () => {
            const creditDetails = this.creditDetailsLocal;
            return (React.createElement(React.Fragment, null, creditDetails &&
                creditDetails.map((creditDetail, index) => {
                    const { creditNumber, note, creditAmount, distributorId } = creditDetail;
                    return (React.createElement(credit_info_1.CreditInfo, { key: index, creditNumber: creditNumber, note: note, creditAmount: formatUsd_1.formatUsd(creditAmount), distributorOptions: this.props.distributorOptions, distributorSelected: distributorId, onChange: this.handleOrderCreditChange(creditDetail), onSelect: this.handleSelectCredit(creditDetail), shouldDisableCreditAmount: true }));
                })));
        };
        this.handleCreate = () => {
            if (this.showNewCreditInfo) {
                this.props.onCreateCredit(this.newCreditDetail);
            }
            else {
                this.props.onCreateTracking(this.newTrackingDetail);
            }
            this.resetNewTrackingDetail();
        };
        this.handleSubmit = () => {
            this.props.onSubmit(this.trackingDetailsLocal, this.creditDetailsLocal);
        };
        this.handleCreditToggle = () => {
            this.showNewCreditInfo = !this.showNewCreditInfo;
        };
        this.isChanged = () => this.status === ui_1.FormStatus.Dirty;
    }
    componentWillMount() {
        for (const detail of this.props.trackingDetails) {
            this.trackingDetailsLocal.push(ramda_1.clone(detail));
        }
        for (const detail of this.props.creditDetails) {
            this.creditDetailsLocal.push(ramda_1.clone(detail));
        }
    }
    componentWillReceiveProps(newProps) {
        for (const detail of newProps.trackingDetails) {
            const detailLocalFound = this.trackingDetailsLocal.find(dl => dl.id === detail.id);
            if (!detailLocalFound) {
                this.trackingDetailsLocal.push(ramda_1.clone(detail));
            }
        }
        for (const creditDetail of newProps.creditDetails) {
            const creditLocalFound = this.trackingDetailsLocal.find(cl => cl.id === creditDetail.id);
            if (!creditLocalFound) {
                this.creditDetailsLocal.push(ramda_1.clone(creditDetail));
            }
        }
    }
    get shouldDisableCreate() {
        const { trackingNumber, trackingLink, shippingCost, distributorId } = this.newTrackingDetail;
        const { creditNumber, note, creditAmount, distributorId: creditDistributorId } = this.newCreditDetail;
        const shippingCostIsValid = !Number.isNaN(Number(shippingCost));
        const creditAmoutIsValid = !Number.isNaN(Number(creditAmount));
        const invalidNewTracking = !trackingNumber ||
            !trackingLink ||
            !shippingCostIsValid ||
            !distributorId;
        const invalidNewCredit = !creditNumber || !note || !creditAmoutIsValid || !creditDistributorId;
        return this.showNewCreditInfo ? invalidNewCredit : invalidNewTracking;
    }
    render() {
        return (React.createElement(modal_1.Modal, { width: "1000px", height: "550px", onCancel: this.props.onCancel },
            React.createElement(material_ui_1.Typography, { variant: "headline" }, "Order Tracking Detail"),
            React.createElement("div", { className: this.props.classes.trackingInfoContainer },
                React.createElement(ui_1.UiForm, { buttons: [
                        React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.props.onCancel }, "Close"),
                        "Save"
                    ], isChanged: this.isChanged, status: this.status, id: "render-new-message", onSubmit: this.handleSubmit, title: "Order Tracking List" },
                    this.renderOrderTrackingDetails(),
                    this.renderOrderTrackingCreditDetails()),
                React.createElement(ui_1.UiForm, { buttons: [
                        React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.props.onCancel }, "Close"),
                        "Create"
                    ], id: "render-new-message", onSubmit: this.handleCreate, title: "Create New Order Tracking", shouldDisableSave: this.shouldDisableCreate },
                    React.createElement("div", { style: { width: "100px" } },
                        React.createElement(switch_1.MaterialSwitch, { label: "Credit", value: "Credit", checked: this.showNewCreditInfo, onChange: this.handleCreditToggle })),
                    this.showNewCreditInfo
                        ? this.renderNewCreditDetail()
                        : this.renderNewTrackingDetail()))));
    }
};
__decorate([
    mobx_1.observable
], OrderTrackingDetailUnstyled.prototype, "newTrackingDetail", void 0);
__decorate([
    mobx_1.observable
], OrderTrackingDetailUnstyled.prototype, "newCreditDetail", void 0);
__decorate([
    mobx_1.observable
], OrderTrackingDetailUnstyled.prototype, "trackingDetailsLocal", void 0);
__decorate([
    mobx_1.observable
], OrderTrackingDetailUnstyled.prototype, "creditDetailsLocal", void 0);
__decorate([
    mobx_1.observable
], OrderTrackingDetailUnstyled.prototype, "showNewCreditInfo", void 0);
__decorate([
    mobx_1.observable
], OrderTrackingDetailUnstyled.prototype, "status", void 0);
__decorate([
    mobx_1.computed
], OrderTrackingDetailUnstyled.prototype, "shouldDisableCreate", null);
OrderTrackingDetailUnstyled = __decorate([
    mobx_react_1.observer
], OrderTrackingDetailUnstyled);
exports.OrderTrackingDetail = decorate(OrderTrackingDetailUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-review/components/order-tracking-detail/order-tracking-detail.tsx
// module id = 3581
// module chunks = 0